import { EyeOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { useCallback, useMemo } from 'react';
import { makePreviewApiData } from '../selectItems/comp/preview/CgPreviewHandler';
import { usePreviewModal } from '../selectItems/comp/preview/Preview';
import { AdditionalPayload } from '../selectItems/XmRule';
import { RuleGroup } from '../selectItems/XmRuleList';

interface RuleFormValues {
  class: string;
  hw_type: string;
  subsystem: string;
  rules?: (RuleGroup & {
    class?: string;
    hw_type?: string;
    subsystem?: string;
  })[];
  rule?: RuleGroup & {
    class?: string;
    hw_type?: string;
    subsystem?: string;
  };
}

interface XmPreviewRuleFormProps {
  style?: React.CSSProperties;
  linuxExclude?: boolean;
  activeIndexTab?: number;
  additionalPayload?: AdditionalPayload;
}

const XmPreviewRuleForm = ({ style, linuxExclude = false, activeIndexTab, additionalPayload }: XmPreviewRuleFormProps) => {
  //FormState
  const form = Form.useFormInstance<RuleFormValues>();
  const formValues = useWatch([], form); //formValues.getFieldsValue()
  const { class: classValue, hw_type: hwTypeValue, subsystem: subsystemValue, rules, rule } = formValues || {};

  const currentRule = rule || rules?.[activeIndexTab];

  const isDisabledPreview = useMemo(() => {
    return !(
      currentRule?.items?.length ||
      currentRule?.regex?.length ||
      currentRule?.tags?.every((t) => !!t.tag_id)
    );
  }, [currentRule]);

  //ModalHook
  const [showPreview, contextHolderRegex] = usePreviewModal();
  const handlePreview = useCallback(() => {
    if (!currentRule) return;

    showPreview({
      subsystem: currentRule?.subsystem || subsystemValue,
      hw_type: currentRule?.hw_type || hwTypeValue,
      data: makePreviewApiData({
        cls: currentRule?.class || classValue,
        hwType: currentRule?.hw_type || hwTypeValue,
        subsystem: currentRule?.subsystem || subsystemValue,
        parents: currentRule?.parents,
        regex: currentRule?.regex,
        tags: currentRule?.tags,
        exclude: currentRule?.exclude,
        items: currentRule?.items
      }, linuxExclude, additionalPayload),
    });
  }, [currentRule, showPreview, linuxExclude, additionalPayload]);

  return (
    <div style={{ ...style, display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
      <Button onClick={handlePreview} icon={<EyeOutlined />} disabled={isDisabledPreview}>
        Preview
      </Button>
      {contextHolderRegex}
    </div>
  );
};


export default XmPreviewRuleForm;
